import { render, staticRenderFns } from "./TicketsAdd.vue?vue&type=template&id=951196da&lang=pug&"
import script from "./TicketsAdd.vue?vue&type=script&lang=js&"
export * from "./TicketsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports